{
  "noPrice": "No price",
  "noPriceText": "{{name}} has no price on this store's list: it cannot be sold here.",
  "gate": {
    "notPaired": "This browser is not a register",
    "notPairedText": "The till works on the browser of a register. A manager pairs this browser with a register on the Cash registers page.",
    "registers": "Cash registers",
    "unavailable": "The till cannot start",
    "noShift": "{{register}} has no open shift",
    "noShiftText": "Count the float in the drawer to open the shift, then sell.",
    "noShiftAsk": "Ask a cashier or a manager to open the shift of this register.",
    "openShift": "Open the shift"
  },
  "header": {
    "cashier": "Cashier: {{name}}",
    "shift": "shift opened {{time}}",
    "offline": "Offline",
    "pickups_one": "{{count}} pickup waiting",
    "pickups_other": "{{count}} pickups waiting",
    "return": "Return",
    "pickupsButton": "Pickups",
    "parked": "Parked",
    "more": "More actions",
    "cod": "Courier cash",
    "movement": "Cash in or out",
    "drawer": "Open the drawer",
    "x": "X report",
    "close": "Close the shift",
    "closeBusy": "Finish the ticket first",
    "fullscreen": "Full screen",
    "exit": "Leave the till",
    "sales": "Sales"
  },
  "catalog": {
    "title": "Products",
    "search": "Scan or search a product (F2)",
    "clear": "Clear the search",
    "view": "Products shown",
    "favorites": "Favourites",
    "all": "All",
    "loading": "Loading the catalog…",
    "empty": "Nothing to sell here yet",
    "noMatch": "Nothing matches “{{query}}”",
    "notFound": "No product with the code {{code}}",
    "variants_one": "{{count}} variant",
    "variants_other": "{{count}} variants",
    "from": "from {{amount}}",
    "show": "Back to the products"
  },
  "stock": {
    "left": "{{quantity}} {{unit}} left here",
    "leftShort": "{{quantity}} left",
    "out": "Out of stock"
  },
  "favorites": {
    "add": "Add {{name}} to the favourites",
    "remove": "Take {{name}} off the favourites",
    "full": "A register shows {{max}} favourites at most"
  },
  "keypad": {
    "back": "Erase (double tap: clear)"
  },
  "ticket": {
    "title": "Ticket",
    "walkIn": "Walk-in customer",
    "addCustomer": "Add a customer by phone",
    "empty": "The ticket is empty",
    "emptyHint": "Scan a product or tap it on the left.",
    "unknown": "No longer sold here",
    "unknownText": "Take the lines no longer sold here off the ticket first.",
    "answer": "To answer: {{names}}",
    "short": "Only {{quantity}} left here",
    "less": "One less {{name}}",
    "more": "One more {{name}}",
    "discount": "Discount",
    "promoCode": "Promotion code",
    "park": "Park",
    "gross": "Before discounts",
    "discounts": "Discounts",
    "total": "Total",
    "overLimit": "The discounts are above your limit: a manager allows them at payment.",
    "pay": "Pay {{amount}}",
    "full": "A ticket holds {{max}} lines at most",
    "show": "Ticket ({{count}}) · {{amount}}",
    "lineDiscount": "−{{amount}} · {{unit}} per unit · {{percent}}%",
    "noWholesale": "No wholesale price",
    "removeLine": "Remove {{name}} from the ticket"
  },
  "line": {
    "editing": "What the keypad changes",
    "quantity": "Quantity",
    "discountAmount": "Discount TND",
    "discountPercent": "Discount %",
    "gross": "Price × quantity",
    "discount": "Discount",
    "total": "Line total",
    "customizations": "Made to measure",
    "remove": "Remove the line",
    "apply": "Apply",
    "add": "Add to the ticket",
    "unitPrice": "Unit price",
    "perUnit": "Per unit"
  },
  "variants": {
    "priceRange": "{{from}} to {{to}}",
    "pick": "Choose the {{option}}",
    "choose": "Choose a variant",
    "add": "Add {{label}}"
  },
  "discount": {
    "title": "Discount on the ticket",
    "hint": "Shared between the lines, on {{amount}}.",
    "mode": "Discount as",
    "apply": "Give {{amount}} off",
    "removeAll": "No discount",
    "overLimit": "Above your limit of {{percent}} %: the sale will need a manager."
  },
  "code": {
    "title": "Promotion code",
    "hint": "The code the customer gives. A promotion that asks for it then applies to the ticket.",
    "apply": "Apply",
    "remove": "Remove the code"
  },
  "customer": {
    "title": "Customer",
    "hint": "Find them by phone or name, or record a new customer.",
    "walkIn": "Walk-in customer"
  },
  "park": {
    "title": "Park the ticket",
    "hint": "It waits at this register until it is taken up again.",
    "label": "Name to find it",
    "labelHint": "Optional: the customer's name, “blue jacket”…",
    "confirm": "Park",
    "done": "Ticket parked"
  },
  "parked": {
    "title": "Parked tickets",
    "none": "No ticket parked",
    "noneHint": "Tickets put aside at this register show here.",
    "busy": "Finish or park the ticket on the screen before taking another one.",
    "unnamed": "Ticket",
    "lines_one": "{{count}} line",
    "lines_other": "{{count}} lines",
    "by": "parked by {{name}}, {{time}}",
    "recall": "Take up"
  },
  "pay": {
    "title": "Payment",
    "total": "To pay",
    "left": "Left to pay",
    "over": "Too much",
    "pickMethod": "Tap how the customer pays. Several methods make a split payment.",
    "amount": "Amount",
    "removePayment": "Remove this payment",
    "shortCash": "Less than the amount: the cash handed over must cover it.",
    "keypadHint": "Tap an amount to type it here.",
    "complete": "Complete the sale"
  },
  "pending": {
    "title": "Sale not confirmed",
    "text": "The server did not answer. Send it again: a sale sent twice is recorded once.",
    "retry": "Send again",
    "abandon": "Change the ticket",
    "abandonConfirm": "If the sale went through, it is in the orders with its receipt. Change the ticket anyway?"
  },
  "done": {
    "title": "Sale done · {{number}}",
    "order": "Order {{number}}",
    "total": "Paid",
    "print": "Print again",
    "next": "Next customer"
  },
  "returns": {
    "title": "Return at the till",
    "hint": "From the receipt: the items go back on this store's shelf, the money goes back, a credit note is issued.",
    "number": "Receipt number",
    "find": "Find",
    "notFound": "No receipt with this number",
    "reprint": "Print the receipt again",
    "sold": "{{quantity}} sold, {{amount}}",
    "returnable": "{{quantity}} can come back",
    "nothingLeft": "nothing left to return",
    "less": "One less {{name}} back",
    "more": "One more {{name}} back",
    "refundMethod": "Money back",
    "asPaid": "As it was paid",
    "lateTitle": "The return period is over",
    "lateText": "A manager accepts it: they are asked when you take the items back.",
    "lateAllowed": "You may accept it all the same.",
    "confirm": "Take back · {{amount}}",
    "doneTitle": "Return recorded",
    "creditNote": "Credit note {{number}}",
    "giveBack": "Give back in cash",
    "noRefund": "Nothing to give back: the sale was not paid.",
    "confirmManager": "Ask a manager · take back {{amount}}",
    "findSale": "No receipt? Find the sale"
  },
  "pickups": {
    "title": "Pickups at this store",
    "hint": "Online orders the customer collects here. What is still due is paid at the till.",
    "none": "No pickup waiting",
    "ready": "Ready",
    "notReady": "Not ready yet",
    "due": "{{amount}} due",
    "paid": "Paid",
    "collect": "Hand over",
    "payAndCollect": "Pay and hand over",
    "payTitle": "Payment for {{number}}"
  },
  "cod": {
    "title": "Courier cash",
    "hint": "The cash a courier brings for the orders they delivered, into this drawer.",
    "none": "No cash on delivery waiting",
    "confirm": "Put {{amount}} in the drawer"
  },
  "x": {
    "title": "X report",
    "hint": "{{register}}: the shift so far. It does not close anything.",
    "figures": "Taken in this shift"
  },
  "drawer": {
    "title": "Open the drawer",
    "hint": "The drawer of {{register}} opens with a no-sale slip, and the activity log says who opened it.",
    "reason": "Why",
    "confirm": "Open"
  },
  "receipt": {
    "types": {
      "receipt": "Receipt",
      "invoice": "Invoice",
      "creditNote": "Credit note"
    },
    "copy": "Copy",
    "taxId": "Tax ID",
    "register": "Register: {{name}}",
    "cashier": "Cashier: {{name}}",
    "order": "Order {{number}}",
    "customer": "Customer: {{name}}",
    "corrects": "Corrects {{number}}",
    "refundLine": "Refund",
    "discount": "Discount",
    "discounts": "Discounts",
    "total": "Total",
    "totalCredit": "Credited",
    "vat": "VAT {{rate}} % on {{base}}",
    "tendered": "Handed over",
    "change": "Change",
    "refunded": "Given back · {{method}}",
    "amountsIn": "Amounts in TND, VAT included.",
    "thanks": "Thank you, see you soon!",
    "noSale": "No sale",
    "cancelled": "Cancelled",
    "paymentCorrected": "Payment corrected"
  },
  "sales": {
    "title": "Sales of this till",
    "hint": "Find a ticket to print it again, take items back or put it right.",
    "search": "Receipt, customer, amount, or scan a product",
    "period": "Period",
    "periods": {
      "shift": "This shift",
      "today": "Today",
      "7d": "7 days",
      "day": "A day"
    },
    "date": "Day",
    "store": "All registers of the store",
    "none": "No ticket yet",
    "noneHint": "Nothing was sold here in this period.",
    "noMatch": "No ticket matches",
    "noMatchHint": "Try another period or all the registers; if the sale cannot be found, take the items back without a receipt.",
    "more": "The latest {{count}} tickets are shown: narrow the search to see older ones.",
    "states": {
      "paid": "Paid",
      "partlyPaid": "Partly paid",
      "partlyReturned": "Partly returned",
      "returned": "Returned",
      "cancelled": "Cancelled",
      "refund": "Without receipt"
    },
    "kinds": {
      "pickup": "Pickup"
    },
    "lines_one": "{{count}} line",
    "lines_other": "{{count}} lines",
    "noReceipt": "Take back without a receipt",
    "back": "All tickets",
    "open": "Open {{number}}"
  },
  "ticketView": {
    "title": "Ticket {{number}}",
    "refundTitle": "Taken back without a receipt · {{number}}",
    "order": "Order {{number}}",
    "lines": "Items",
    "sold": "{{quantity}} × {{price}}",
    "discount": "{{amount}} off",
    "returned": "{{quantity}} returned",
    "payments": "Money",
    "noPayment": "No payment.",
    "refund": "Refund",
    "voided": "Voided",
    "refunded": "{{amount}} refunded",
    "correct": "Correct",
    "documents": "Documents",
    "print": "Print",
    "openA4": "Open to print (A4)",
    "cancelled": "Cancelled on {{date}} by {{by}}",
    "approvedBy": "allowed by {{name}}",
    "late": "Past its return period: a manager accepts a return.",
    "manager": "A manager allows it",
    "backOffice": "Open in the back office",
    "backToTicket": "Back to the ticket",
    "customerSet": "{{name}} is the customer of this ticket",
    "actions": {
      "reprint": "Print again",
      "takeBack": "Take items back",
      "cancel": "Cancel the sale",
      "correctPayment": "Correct a payment",
      "invoice": "Invoice",
      "setCustomer": "Add the customer"
    },
    "listPrice": "list price {{price}}"
  },
  "cancel": {
    "title": "Cancel {{number}}",
    "hint": "Everything comes back on this store's shelf and the customer gets the money back. A credit note corrects the receipt.",
    "items": "Items back on the shelf",
    "voided": "Taken out of this shift, as if never paid",
    "refunded": "Refunded from this drawer",
    "reason": "Why",
    "confirm": "Cancel the sale",
    "confirmManager": "Ask a manager · cancel the sale",
    "done": "Sale cancelled",
    "doneTitle": "Sale {{number}} cancelled"
  },
  "correct": {
    "title": "Correct the payment · {{method}} {{amount}}",
    "hint": "Enter the payment as it really was made: the wrong one is voided in this shift and the ticket stays the same.",
    "confirm": "Record the right payment",
    "confirmManager": "Ask a manager · record it",
    "done": "Payment corrected"
  },
  "invoice": {
    "title": "Invoice for {{number}}",
    "hint": "At the customer's request, with their name and tax ID. It prints on A4 from its page.",
    "buyerName": "Name or company",
    "buyerTaxId": "Tax ID",
    "buyerTaxIdHint": "For a company (matricule fiscal).",
    "buyerAddress": "Address",
    "confirm": "Issue the invoice",
    "done": "Invoice {{number}} issued",
    "doneHint": "Open it to print it on A4, or find it later in this ticket's documents."
  },
  "noReceipt": {
    "title": "Take back without a receipt",
    "hint": "When the sale cannot be found: the items come back at today's price, into this store's stock.",
    "search": "Scan or type the product brought back",
    "notFound": "Not sold at this till.",
    "empty": "Add the items brought back.",
    "price": "{{price}} today",
    "remove": "Remove {{name}}",
    "cash": "The money is given back in cash from this drawer, and a credit note is printed.",
    "confirm": "Give back {{amount}} in cash",
    "confirmManager": "Ask a manager · give back {{amount}}",
    "doneTitle": "Items taken back · {{number}}"
  },
  "approval": {
    "title": "Ask a manager",
    "hint": "A manager signs in here for this one action. Your session stays open.",
    "username": "Manager's username",
    "password": "Password",
    "confirm": "Allow",
    "given": "Allowed by {{name}}",
    "permissions": {
      "voidSale": "Cancel a sale or correct a payment",
      "refundWithoutReceipt": "Take items back without a receipt",
      "acceptLateReturn": "Accept a return after its period",
      "giveLargeDiscount": "Give discounts above the cashier's limit"
    },
    "invalid": {
      "credentials": "Wrong username or password.",
      "permission": "This person may not allow it.",
      "site": "This person does not work at this store.",
      "expired": "The approval is no longer valid: ask again."
    }
  },
  "mode": {
    "label": "Prices",
    "retail": "Retail",
    "wholesale": "Wholesale",
    "banner": "Wholesale prices",
    "confirm": "Switch the prices of this ticket? Its discounts and the prices you typed are removed: they were given against the other prices.",
    "noWholesaleText": "{{name}} has no wholesale price: set it on the product, or sell it in retail mode."
  },
  "hint": {
    "add": "Add",
    "free_one": "Add {{count}} more: free · {{name}}",
    "free_other": "Add {{count}} more: free · {{name}}",
    "reduced_one": "Add {{count}} more at −{{percent}} % · {{name}}",
    "reduced_other": "Add {{count}} more at −{{percent}} % · {{name}}",
    "pieces_one": "{{quantity}} more for {{name}}",
    "pieces_other": "{{quantity}} more for {{name}}",
    "amount": "{{amount}} more for {{name}}",
    "pack": "Add {{quantity}} × {{product}}: {{name}}"
  }
}
